import React from 'react';
import { motion } from 'framer-motion';
import { Container, ContentContainer, Content, DismissButton, } from './toast.styles';
import text from './text.json';
var toastMotion = {
    entering: { scale: 1, opacity: 1 },
    entered: {},
    exiting: { opacity: 0, scale: 0.4 },
    exited: {},
};
var toastDuration = {
    entering: 800,
    entered: 0,
    exiting: 1200,
    exited: 0,
};
var Toast = function (_a) {
    var children = _a.children, appearance = _a.appearance, onDismiss = _a.onDismiss, showDismissButton = _a.showDismissButton, transitionDuration = _a.transitionDuration, transitionState = _a.transitionState;
    return (React.createElement(motion.div, { initial: { scale: 0, opacity: 0 }, animate: toastMotion[transitionState], transition: {
            duration: transitionDuration / toastDuration[transitionState],
        } },
        React.createElement(Container, { appearance: appearance, onClick: function () { return onDismiss(); } },
            React.createElement(ContentContainer, null,
                React.createElement(Content, null, children),
                showDismissButton && (React.createElement(DismissButton, { "data-testid": "dismiss-button", role: "button", onClick: function () { return onDismiss(); } }, text.dismissButton))))));
};
export default Toast;
